"use client"

import { Suspense } from "react"
import { MarketingLayout } from "@/components/pages/landing/marketing-layout"
import { SiteFooter } from "@/components/pages/landing/site-footer"
import { HomeHero } from "@/components/pages/landing/home-hero"
import { WhoWeAre } from "@/components/pages/landing/who-we-are"
import { WhatWeDo } from "@/components/pages/landing/what-we-do"
import { PlatformSection } from "@/components/pages/landing/platform-section"
import { OurPlayers } from "@/components/pages/landing/our-players"
import { SocialLinks } from "@/components/pages/landing/social-links"

function HomePageContent() {
  return (
    <MarketingLayout footer={<SiteFooter />}>
      <HomeHero />
      <WhoWeAre />
      <WhatWeDo />
      <PlatformSection />
      <OurPlayers />
      <SocialLinks />
    </MarketingLayout>
  )
}

export function HomePage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <HomePageContent />
    </Suspense>
  )
}
